/**
 * ESC/POS command byte constants for thermal receipt printers.
 * Reference: Epson ESC/POS Application Programming Guide.
 */

// ─── Control ────────────────────────────────────────────────────────────────

/** Escape character (0x1B) */
export const ESC = 0x1b;
/** Group Separator (0x1D) */
export const GS = 0x1d;
/** Line Feed */
export const LF = 0x0a;
/** Form Feed (page cut on some printers) */
export const FF = 0x0c;

// ─── Initialisation ─────────────────────────────────────────────────────────

/** ESC @ — Initialize printer (reset to default settings) */
export const INIT = new Uint8Array([ESC, 0x40]);

// ─── Text alignment ─────────────────────────────────────────────────────────

/** ESC a 0 — Align left */
export const ALIGN_LEFT = new Uint8Array([ESC, 0x61, 0x00]);
/** ESC a 1 — Align center */
export const ALIGN_CENTER = new Uint8Array([ESC, 0x61, 0x01]);
/** ESC a 2 — Align right */
export const ALIGN_RIGHT = new Uint8Array([ESC, 0x61, 0x02]);

// ─── Text emphasis ──────────────────────────────────────────────────────────

/** ESC E 1 — Bold on */
export const BOLD_ON = new Uint8Array([ESC, 0x45, 0x01]);
/** ESC E 0 — Bold off */
export const BOLD_OFF = new Uint8Array([ESC, 0x45, 0x00]);
/** ESC - 1 — Underline on (1-dot) */
export const UNDERLINE_ON = new Uint8Array([ESC, 0x2d, 0x01]);
/** ESC - 0 — Underline off */
export const UNDERLINE_OFF = new Uint8Array([ESC, 0x2d, 0x00]);

// ─── Text size (GS ! n) ────────────────────────────────────────────────────
// Bits 0-3: height magnification, bits 4-7: width magnification

/** GS ! 0x00 — Normal size (1x width, 1x height) */
export const SIZE_NORMAL = new Uint8Array([GS, 0x21, 0x00]);
/** GS ! 0x10 — Double width (2x width, 1x height) */
export const SIZE_DOUBLE_WIDTH = new Uint8Array([GS, 0x21, 0x10]);
/** GS ! 0x01 — Double height (1x width, 2x height) */
export const SIZE_DOUBLE_HEIGHT = new Uint8Array([GS, 0x21, 0x01]);
/** GS ! 0x11 — Double both (2x width, 2x height) */
export const SIZE_DOUBLE_BOTH = new Uint8Array([GS, 0x21, 0x11]);

// ─── Feed & cut ─────────────────────────────────────────────────────────────

/** ESC d n — Feed n lines */
export const FEED_PREFIX = new Uint8Array([ESC, 0x64]);
/** GS V 0 — Full cut */
export const CUT_FULL = new Uint8Array([GS, 0x56, 0x00]);
/** GS V 1 — Partial cut */
export const CUT_PARTIAL = new Uint8Array([GS, 0x56, 0x01]);

// ─── Cash drawer ────────────────────────────────────────────────────────────

/** ESC p 0 25 250 — Kick cash drawer (pin 2) */
export const CASH_DRAWER_KICK = new Uint8Array([ESC, 0x70, 0x00, 0x19, 0xfa]);

// ─── QR code (GS ( k) ──────────────────────────────────────────────────────

/** QR code model 2 */
export const QR_MODEL_2 = new Uint8Array([GS, 0x28, 0x6b, 0x04, 0x00, 0x31, 0x41, 0x32, 0x00]);
/** QR code error correction level M */
export const QR_ERROR_M = new Uint8Array([GS, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x45, 0x31]);

// ─── Barcode (GS k) ────────────────────────────────────────────────────────

/** GS k 73 — Code128 barcode type */
export const BARCODE_CODE128 = 0x49;
/** GS H 2 — Print barcode text below */
export const BARCODE_TEXT_BELOW = new Uint8Array([GS, 0x48, 0x02]);
/** GS h n — Set barcode height to n dots */
export const BARCODE_HEIGHT_PREFIX = new Uint8Array([GS, 0x68]);
/** GS w n — Set barcode width multiplier */
export const BARCODE_WIDTH_PREFIX = new Uint8Array([GS, 0x77]);

// ─── Paper width presets ────────────────────────────────────────────────────

/** Characters per line for 58mm paper (standard font) */
export const CHARS_58MM = 32;
/** Characters per line for 80mm paper (standard font) */
export const CHARS_80MM = 48;
